module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAMAAABEpIrGAAAAA3NCSVQICAjb4U/gAAAACXBIWXMAAADdAAAA3QFwU6IHAAAAGXRFWHRTb2Z0d2FyZQB3d3cuaW5rc2NhcGUub3Jnm+48GgAAADxQTFRF////RkZd/+hdR0dU/+JcRUVU/+FbRkZV/+FamEhV/55YRkZV/+FaRkZV/+FaRkZV/+FaRkZV/0tV/+FaLRSRSAAAABF0Uk5TAAsLPT12drCwxsbd3eXl/f3gbuwbAAAAdklEQVQ4y+3TOQ7DMAwF0dEuW4vN5P53dZEyFpnCZV77BwRUCMClMuTLKMkBQGiy0AJAOGTpCOCaKJojiSpR9KAw9GAghgeCzcDL8A9+DXYDb8MDwdT3SdWDStaDjO/a3j3Ec72fESAub/T4+d4+15u3zJo9cAEifEIf4pdVjAAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/flags/de.png
// module id = 2183
// module chunks = 0